export const LinkedAssetsColumn = [
    {
        id: "name",
        label: "Name",
        type: "name",
        style: { custom: { width: "calc(100% - 390px)", pl: 0 } },
        disabled: true,
        checked: true,
        sortable: false,
    },
    {
        id: "size",
        label: "Size",
        type: "size",
        style: { custom: { width: 100 } },
        disabled: false,
        checked: true,
        sortable: false,
    },
    {
        id: "created",
        label: "Created",
        type: "date",
        style: { custom: { width: 170 } },
        disabled: false,
        checked: true,
        sortable: false,
    },
    {
        id: "created",
        label: "Owner",
        type: "user",
        style: { custom: { width: 120 } },
        disabled: false,
        checked: true,
        sortable: false,
    },
];

export const LinkedAssetsColumnV2 = [
    {
        id: "name",
        label: "Name",
        type: "name",
        style: { custom: { width: "calc(100% - 390px)", pl: 0 } },
        disabled: true,
        checked: true,
        sortable: false,
    },
    {
        id: "size",
        label: "Size",
        type: "size",
        style: { custom: { width: 100 } },
        disabled: false,
        checked: true,
        sortable: false,
    },
    {
        id: "created",
        label: "Created",
        type: "date",
        style: { custom: { width: 170 } },
        disabled: false,
        checked: true,
        sortable: false,
    },
    {
        id: "owner",
        label: "Owner",
        type: "user",
        style: { custom: { width: 120 } },
        disabled: false,
        checked: true,
        sortable: false,
    },
];

export default LinkedAssetsColumn;
